import React , { Component } from 'react';

import {injectIntl} from 'react-intl';

class NoMatch extends Component {

  render() {
    const {location} = this.props;
    const {formatMessage} = this.props.intl;
    const pathStyle = {
      fontSize: '14pt',
      marginBottom: '10px',
      fontWeight: '300',

    }

    return (
      <div className="row row-cards-pf">
        <div className="col-md-12">
        <div className="card-pf">
          <div className="card-pf-heading">
            <div className="card-pf-heading-details">
            </div>
            <h2 className="card-pf-title">{formatMessage({id:"wrongRequestPathTitle"})}</h2>
          </div>
          <div className="card-pf-body">
            <span>
            <div style={pathStyle}><i className="fa fa-exclamation-triangle"/>  <code>{location.pathname+location.search}</code> {formatMessage({id:"wrongRequestPath"})}</div>

            </span>
          </div>
        </div>
      </div>
    </div>

    );
  }
}

export default injectIntl(NoMatch);



// WEBPACK FOOTER //
// ./src/components/NoMatch.js